import { SpinnerIcon } from '../../../../../assets/images/spinner';
import Confirm from '../../../../Modal/Confirm';
export const Footer = ({ isSaving, onSave, onCancel,confirmMessage,title }) => {
    return (
      <div className="footer">
        <Confirm
          title={title}
          confirmMessage={confirmMessage}
          classList="update boxShadowOnHover"
          getConfirmation={(status) => {
            status && onSave();
          }}
        >
          <button className='update boxShadowOnHover'>
            {isSaving ? (
              <div className="wrapperSaved">
                <SpinnerIcon />
              </div>
            ) : (
              <span>Save</span>
            )}
          </button>
        </Confirm>

        <button className="cancel boxShadowOnHover" onClick={onCancel}>
          Cancel
        </button>
      </div>
    );
}
